import green from "material-ui/colors/green";
import red from "material-ui/colors/red";

export const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "center"
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700]
    }
  },
  buttonProgress: {
    color: green[500],
    position: "relative",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  card: {
    //maxWidth: 400,
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    }),
    marginLeft: "auto"
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  },
  legend: {
    float: "left",
    padding: "0px 10px 10px 0px",
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.54)",
    "&:hover": {
      cursor: "pointer"
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/AssetConsuming/style.js